import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "month" }
const _hoisted_2 = { class: "v-select-calendar__table" }
const _hoisted_3 = ["onClick"]

import { computed, ref, shallowRef, watch } from 'vue';
import dayjs from 'dayjs';


export default /*#__PURE__*/_defineComponent({
  __name: 'VDatePicker',
  props: {
    period: { type: Boolean },
    modelValue: null,
    label: null
  },
  emits: [ "update:modelValue" ],
  setup(__props: any, { emit }) {

const props = __props as { period?: boolean, modelValue?: string, label?: string }




const yearItems = [
  { id: "2022", title: "2022" },
  { id: "2023", title: "2023" },
  { id: "2024", title: "2024" },
  { id: "2025", title: "2025" }
]

const currentDate = dayjs()

const currentMonth = shallowRef(dayjs().startOf("month"))
const weekValues = [ "Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вс" ]
const calendarValues = computed(() => {
  const arr = []
  let item: ({ title: string, date: dayjs.Dayjs, otherMonth?: boolean })[] = []

  for (let i = currentMonth.value.weekday(); i > 0; i--) {
    const date = currentMonth.value.add(-i, "day")
    item.push({ title: date.format("D"), date, otherMonth: true })
  }
  const daysInMonth = currentMonth.value.daysInMonth()
  for (let i = 0; i < daysInMonth; i++) {
    item.push({ title: (i+1).toString(), date: currentMonth.value.date(i+1) })
    if (item.length === 7) {
      arr.push(item)
      item = []
    }
  }
  if (item.length > 0) {
    const lastDate = item[item.length-1].date
    for (let i = 1; i < 7-lastDate.weekday(); i++) {
      const date = lastDate.add(i, "day")
      item.push({ title: date.format("D"), date, otherMonth: true })
    }
    arr.push(item)
  }
  return arr
})


const startDate = shallowRef<dayjs.Dayjs | null>(null)
const endDate = shallowRef<dayjs.Dayjs | null>(null)

watch(() => props.modelValue, (value) => {
  if (value === null) {
    startDate.value = null
    return
  }
  if (startDate.value?.format("DD.MM.YYYY") === value) return
  startDate.value = dayjs(value, "DD.MM.YYYY")
}, { immediate: true })

const clearValue = () => {
  startDate.value = null
  endDate.value = null
  emit("update:modelValue", null)
}

const currentValue = computed(() => {
  if (!startDate.value) return ""
  if (!props.period) {
    return startDate.value.format("DD.MM.YYYY")
  }
  return ""
})

const isHighlighted = computed(() => {
  if (!startDate.value || !endDate.value) return false
  if (startDate.value.isSame(endDate.value)) return false
  return true
})

const onItemClick = (cell: { title: string, date: dayjs.Dayjs }) => {
  if (!cell) return
  if (!props.period) {
    startDate.value = cell.date
    emit("update:modelValue", cell.date.format("DD.MM.YYYY"))
    return
  }
  if (startDate.value && endDate.value) {
    endDate.value = null
    startDate.value = null
  }
  if(startDate.value) { 
    endDate.value = cell.date
    if (endDate.value.unix() < startDate.value.unix()) {
      endDate.value = startDate.value
      startDate.value = cell.date
    }
    return
  }
  startDate.value = cell.date
}

const setMonth = (inc: number) => {
  currentMonth.value = currentMonth.value.add(inc, "month")
}

const setYear = (year: string) => {
  currentMonth.value = currentMonth.value.set("year", parseInt(year))
}


return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createBlock(_component_v_menu, null, {
    activator: _withCtx(({ props: attr }) => [
      _createVNode(_component_v_text_field, _mergeProps({
        "model-value": _unref(currentValue),
        "prepend-inner-icon": "mdi-calendar-today"
      }, attr, {
        label: props.label,
        variant: "outlined",
        readonly: "",
        clearable: "",
        "onClick:clear": clearValue
      }), null, 16, ["model-value", "label"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "v-date-picker" }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "v-date-picker__header",
            onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createVNode(_component_v_select, {
              "model-value": _unref(currentMonth).format('YYYY'),
              "onUpdate:modelValue": setYear,
              variant: "plain",
              items: yearItems,
              density: "compact",
              "hide-details": ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(currentMonth).format("YYYY")), 1)
              ]),
              _: 1
            }, 8, ["model-value"]),
            _createVNode(_component_v_btn, {
              icon: "mdi-chevron-left",
              variant: "flat",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (setMonth(-1)))
            }),
            _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(currentMonth).format("MMMM")), 1),
            _createVNode(_component_v_btn, {
              icon: "mdi-chevron-right",
              variant: "flat",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (setMonth(1)))
            })
          ]),
          _createElementVNode("table", _hoisted_2, [
            _createElementVNode("thead", null, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(weekValues, (item) => {
                return _createElementVNode("th", null, _toDisplayString(item), 1)
              }), 64))
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(calendarValues), (row) => {
                return (_openBlock(), _createElementBlock("tr", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (cell) => {
                    return (_openBlock(), _createElementBlock("td", {
                      onClick: ($event: any) => (onItemClick(cell)),
                      class: _normalizeClass({ 
                otherMonth: cell?.otherMonth,
                active: cell?.date.isSame(_unref(startDate), 'day') || cell?.date.isSame(_unref(endDate), 'day'),
                highlightStart: _unref(isHighlighted) && cell?.date.isSame(_unref(startDate)), 
                highlightEnd: _unref(isHighlighted) && cell?.date.isSame(_unref(endDate)),
                highlight: cell?.date.isAfter(_unref(startDate)) && cell?.date.isBefore(_unref(endDate)),
                currentDate: cell?.date.isSame(_unref(currentDate), 'day')
              })
                    }, _toDisplayString(cell?.title), 11, _hoisted_3))
                  }), 256))
                ]))
              }), 256))
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})